<table
  mat-table
  matSort
  *tdLoading="
    'flight-log-highlights-table';
    mode: 'indeterminate';
    type: 'circle';
    strategy: 'overlay';
    color: 'primary'
  "
  [dataSource]="flightLogs"
  (matSortChange)="onSortChange($event)"
>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    routerLink="/flight-logs/{{ row.id }}"
  ></tr>

  <ng-container matColumnDef="flightTime">
    <!-- NOTE: while the label for this column is "Date of Service", it's important that
      name for this column be 'flightTime'. This is the underlying field the API call needs
      to order by if it is sorted.
    -->
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Date of Service</th>
    <td mat-cell *matCellDef="let fl">
      <span *ngIf="fl" title="{{ fl.flightTime || fl.dateOfService | date: 'full' }}">
        {{ fl.flightTime || fl.dateOfService | date: 'MM/dd/yyyy HH:mm' }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="pilotInCommand">
    <th mat-header-cell *matHeaderCellDef title="Pilot In Command">PIC</th>
    <td mat-cell *matCellDef="let fl" title="Pilot In Command">
      {{ fl?.pilotName || 'Unknown' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="flightType">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Flight Type</th>
    <td mat-cell *matCellDef="let fl">
      <ng-container *ngIf="fl">
        {{ fl.flightTypeDisplay }}
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="flightStatus">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Flight Status</th>
    <td mat-cell *matCellDef="let fl">
      <ng-container *ngIf="fl"> {{ fl.flightStatusDisplay }}</ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="flightSummaryId">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Flight #</th>
    <td mat-cell *matCellDef="let fl">
      <ng-container *ngIf="fl"> {{ fl.flightSummaryIdDisplay }}</ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="base">
    <th mat-header-cell *matHeaderCellDef>Base</th>
    <td mat-cell *matCellDef="let fl">
      <ng-container *ngIf="fl"> {{ fl.transportBase?.name }}</ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="tailNumber">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Tail #</th>
    <td mat-cell *matCellDef="let fl">
      <ng-container *ngIf="fl">
        {{ fl.tailNumberDisplay }}
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Log Status</th>
    <td mat-cell *matCellDef="let fl">
      <ng-container *ngIf="fl">
        {{ fl.logStatusDisplay }}
        <mat-icon
          class="unassigned-warning"
          title="The pilot(s) assigned to this flight could not be automatically determined"
          *ngIf="fl.isUnassigned"
          >warning</mat-icon
        >
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="flightTagNumber">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Flight Tag #</th>
    <td mat-cell *matCellDef="let fl">
      <ng-container *ngIf="fl">
        {{ fl.flightTagNumber }}
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let fl" (click)="$event.stopPropagation()">
      <ng-container *ngIf="fl">
        <fl-flight-log-action-buttons
          [flightLog]="fl"
          [view]="true"
          (flightLogDeleted)="onFlightLogDeleted()"
          (flightLogRestored)="onFlightLogRestored()"
        ></fl-flight-log-action-buttons>
      </ng-container>
    </td>
  </ng-container>
</table>
